document.addEventListener("DOMContentLoaded", function() {
  const tocContainer = document.getElementById("toc");
  if (tocContainer) {
    const headings = document.querySelectorAll("h2, h3, h4, h5, h6");

    headings.forEach((heading, index) => {
      const anchorId = `toc${index}`;
      heading.setAttribute("id", anchorId);

      const tocItem = document.createElement("div");
      tocItem.classList.add(`toc-${heading.tagName.toLowerCase()}`);
      tocItem.innerHTML = `<a href="#${anchorId}">${heading.innerText}</a>`;
      tocContainer.appendChild(tocItem);
    });
  }
});
